import { useBlueChipArtists } from 'hooks/artists/useBlueChipArtists'
import { useMostPopularArtists } from 'hooks/artists/useMostPopularArtists'
import { useTrendingArtists } from 'hooks/artists/useTrendingArtists'
import { ArtworksCategories } from 'hooks/artworks/useArtworksCategoriesFilters'
import useTranslation from 'next-translate/useTranslation'
import { useMemo } from 'react'
import { mapArtistHref } from 'utils/artists'
import { getArtistUrl, getArtworksCategoryUrl } from 'utils/urls'

export function useArtistsNavigationItems() {
  const { t } = useTranslation('common')
  const { data: blueChipArtists } = useBlueChipArtists()
  const { data: mostPopularArtists } = useMostPopularArtists()
  const { data: trendingArtists } = useTrendingArtists()

  const mappedBlueChipArtists = useMemo(
    () => mapArtistHref(blueChipArtists),
    [blueChipArtists]
  )

  const mappedMostPopularArtists = useMemo(
    () => mapArtistHref(mostPopularArtists),
    [mostPopularArtists]
  )

  const mappedTrendingArtists = useMemo(
    () =>
      trendingArtists?.map(artist => ({
        ...artist,
        href: getArtistUrl(artist.name || '', artist.id || 0),
      })),
    [trendingArtists]
  )

  const nationalities = useMemo(() => {
    return [
      {
        label: t('extended_nav.european_artists'),
        href: getArtworksCategoryUrl(ArtworksCategories.european),
      },
      {
        label: t('extended_nav.american_artists'),
        href: getArtworksCategoryUrl(ArtworksCategories.american),
      },
      {
        label: t('extended_nav.african_artists'),
        href: getArtworksCategoryUrl(ArtworksCategories.african),
      },
      {
        label: t('extended_nav.asian_artists'),
        href: getArtworksCategoryUrl(ArtworksCategories.asian),
      },
    ]
  }, [])

  return {
    blueChipArtists: mappedBlueChipArtists,
    mostPopularArtists: mappedMostPopularArtists,
    trendingArtists: mappedTrendingArtists,
    nationalities,
  }
}
